import React from 'react';

export default function DownloadCommandIcon() {
    return (
        <svg
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M7.00004 0.333984C7.36823 0.333984 7.66671 0.632461 7.66671 1.00065V7.39118L9.86197 5.19591C10.1223 4.93556 10.5444 4.93556 10.8048 5.19591C11.0651 5.45626 11.0651 5.87837 10.8048 6.13872L7.47145 9.47206C7.2111 9.73241 6.78899 9.73241 6.52864 9.47206L3.1953 6.13872C2.93495 5.87837 2.93495 5.45626 3.1953 5.19591C3.45565 4.93556 3.87776 4.93556 4.13811 5.19591L6.33337 7.39118V1.00065C6.33337 0.632461 6.63185 0.333984 7.00004 0.333984ZM1.00004 8.33398C1.36823 8.33398 1.66671 8.63246 1.66671 9.00065V11.6673C1.66671 11.8441 1.73695 12.0137 1.86197 12.1387C1.98699 12.2637 2.15656 12.334 2.33337 12.334H11.6667C11.8435 12.334 12.0131 12.2637 12.1381 12.1387C12.2631 12.0137 12.3334 11.8441 12.3334 11.6673V9.00065C12.3334 8.63246 12.6319 8.33398 13 8.33398C13.3682 8.33398 13.6667 8.63246 13.6667 9.00065V11.6673C13.6667 12.1978 13.456 12.7065 13.0809 13.0815C12.7058 13.4566 12.1971 13.6673 11.6667 13.6673H2.33337C1.80294 13.6673 1.29423 13.4566 0.91916 13.0815C0.544088 12.7065 0.333374 12.1978 0.333374 11.6673V9.00065C0.333374 8.63246 0.631851 8.33398 1.00004 8.33398Z"
                fill="#5D636F"
            />
        </svg>
    );
}
